import Box from "@mui/material/Box";
import { cleanProps } from "../internal/cleanProps";
import { tokens } from "../tokens";
import type { LabelledValueProps } from "../types";

/**
 * ADR-20261102-h2fd: a bold label beside its value on one line, as H2 screen 6 shows the
 * declaration date. `underField` pulls it up under the form field above, by the 16px H2 removes.
 */
export function LabelledValue({ label, value, underField, testId }: Readonly<LabelledValueProps>) {
  const text = { fontSize: 17, color: tokens.colour.neutral.ink } as const;
  return (
    <Box
      {...cleanProps({ "data-testid": testId })}
      sx={{ maxWidth: { xs: "none", sm: 280 }, marginTop: underField === true ? "-16px" : 0 }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "baseline", columnGap: "0.28em", rowGap: "4px" }}>
        <Box component="span" sx={{ ...text, fontWeight: tokens.typography.weights.bold }}>
          {label}
        </Box>
        <Box component="span" sx={text}>
          {value}
        </Box>
      </Box>
    </Box>
  );
}
